export enum DesignEditorPlugin {
  APP_IMAGE_FILTERS = 'app-image-filters',
  APP_ADVANCED_PERSONALIZATION = 'app-advanced-personalization',
  APP_GRAPHICS = 'app-graphics',
  APP_TEXT_EFFECTS = 'app-text-effects',
  APP_SHUTTERSTOCK_ESSENTIAL = 'app-shutterstock-essential',
  APP_SHUTTERSTOCK_FULL = 'app-shutterstock-full',
  APP_SHUTTERSTOCK = 'app-shutterstock',
  APP_FONTS = 'app-fonts',
  APP_BACKGROUND_REMOVAL = 'app-background-removal',
  APP_IMAGE_ENHANCEMENT = 'app-image-enhancement',
  APP_AI_PERSONALIZATION = 'app-ai-personalization',
  APP_SHOPIFY_PERSONALIZATION = 'app-shopify-personalization',
  APP_EMAIL_WORKFLOW_PERSONALIZATION = 'app-email-workflow-personalization',
  APP_PERSONALIZATION_STUDIO = 'personalization-studio',

  // todo: remove after 10th of October 2023. GP-1272
  APP_GETTY_IMAGES = 'app-getty-images',
}

export const DesignEditorAllPlugins = [
  DesignEditorPlugin.APP_IMAGE_FILTERS,
  DesignEditorPlugin.APP_ADVANCED_PERSONALIZATION,
  DesignEditorPlugin.APP_GRAPHICS,
  DesignEditorPlugin.APP_TEXT_EFFECTS,
  DesignEditorPlugin.APP_SHUTTERSTOCK_ESSENTIAL,
  DesignEditorPlugin.APP_SHUTTERSTOCK_FULL,
  DesignEditorPlugin.APP_SHUTTERSTOCK,
  DesignEditorPlugin.APP_GETTY_IMAGES,
  DesignEditorPlugin.APP_FONTS,
  DesignEditorPlugin.APP_BACKGROUND_REMOVAL,
  DesignEditorPlugin.APP_IMAGE_ENHANCEMENT,
  DesignEditorPlugin.APP_AI_PERSONALIZATION,
];

export enum DesignEditorEffectPlugin {
  APP_BACKGROUND_REMOVAL = 'app-background-removal',
  APP_IMAGE_ENHANCEMENT = 'app-image-enhancement',
}

export const DesignEditorPluginNames = {
  [DesignEditorPlugin.APP_ADVANCED_PERSONALIZATION]: 'txt_design_editor_collections_tab',
  [DesignEditorPlugin.APP_GRAPHICS]: 'txt_design_editor_graphics_tab',
  [DesignEditorPlugin.APP_SHUTTERSTOCK]: 'txt_design_editor_shutterstock_tab',
};
